var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleReadyToEat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    fill: "#d2f0eb",
    r: 23
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.227 20.5h15.586a1 1 0 00.993-.876l.865-6.924a1 1 0 00-.992-1.124H14.362a1 1 0 00-.992 1.124l.865 6.924a1 1 0 00.992.876zM15.252 34.246h15.537a1 1 0 00.994-.89l.921-8.289a1 1 0 00-.994-1.11H14.331a1 1 0 00-.994 1.11l.922 8.29a1 1 0 00.993.89z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.414 15.444h23.213M11.414 27.558h23.213"
  })))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--ready-to-eat-6c1fd4989d8fc9c444288e9974ed8ac9.svg";
export { SvgIconCircleReadyToEat as Component };